// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2GDA8","large":"styles_large__nKD9k"};